import "./App.css";
import Header from "./components/head-footer/Header";
import Footer from "./components/head-footer/Footer";
import { Routes, Route } from "react-router-dom";
import Home from "./components/common-pages/NgoWaters";
import AboutUs from "./components/common-pages/AboutPage";
import Contact from "./components/common-pages/ContactUs";
import BulkOrderForm from "./components/common-pages/BulkOrderForm";
import NotFound404 from "./components/legalPage/NotFound404";
import Quality from "./components/legalPage/Quality";
import Discount from "./components/legalPage/Discount";
import Distributor from "./components/legalPage/Distributor";
import Feedback from "./components/legalPage/Feedback";
import Career from "./components/legalPage/Career";
import TermsConditions from "./components/legalPage/TermsConditions";
import NewsStories from "./components/legalPage/NewsStories";
import AskQuestion from "./components/legalPage/AskQuestion";
import Media from "./components/legalPage/Media";
import Profile from "./user/Profile";
import BlogPage from "./components/common-pages/BlogPage";
import AuthPage from "./user/AuthPage";
import Product from "./components/common-pages/Product";
import PrivacyPolicy from "./components/legalPage/PrivacyPolicy";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./user/ProtectedRoute";
import FAQPage from "./components/common-pages/FAQPage";
import ResourceDownload from "./components/legalPage/ResourceDownload";
import CompanyHierarchy from "./components/CompanyHierarchy/CompanyHierarchy";
import HorecaPage from "./components/Special Page/HorecaPage";
import RefundReturn from "./components/legalPage/RefundReturn";

function App() {
  return (
    <AuthProvider>
      <div className="App">
        <Header />
        <div className="main-content">
          <Routes>
            {/* Public Routes */}
            <Route path="/" element={<Home />} />
            <Route path="/aboutus" element={<AboutUs />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/bulkorder" element={<BulkOrderForm />} />
            <Route path="/quality" element={<Quality />} />
            <Route path="/discount" element={<Discount />} />
            <Route path="/distributor" element={<Distributor />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/career" element={<Career />} />
            <Route path="/t&c" element={<TermsConditions />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            <Route path="/news" element={<NewsStories />} />
            <Route path="/askquestion" element={<AskQuestion />} />
            <Route path="/media" element={<Media />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/product" element={<Product />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/resources" element={<ResourceDownload />} />
            <Route path="/hierarchy" element={<CompanyHierarchy />} />
            <Route path="/horeca" element={<HorecaPage />} />
            <Route path="/refund_return" element={<RefundReturn />} />
            {/* Protected Route */}
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <Profile />
                </ProtectedRoute>
              }
            />

            {/* Login Route */}
            <Route path="/login" element={<AuthPage />} />

            {/* Catch-all Route */}
            <Route path="*" element={<NotFound404 />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </AuthProvider>
  );
}

export default App;
